export default __webpack_public_path__ + "static/media/group-option-gender-selected.228ef069.svg";